// Do not change order of this enum
/* eslint-disable perfectionist/sort-enums */
export enum AccountSettingsFormSection {
  Profile = 'Profile',
  PersonalInformation = 'PersonalInformation',
  ContactInformation = 'ContactInformation',
  ProfessionalInformation = 'ProfessionalInformation',
  LoginPassword = 'LoginPassword',
  SitePreferences = 'SitePreferences',
}
